// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"18":"css/admin/seo_one_click_theme-custom-css-page","266":"css/style"}[chunkId] + ".css";
};